module.exports = __webpack_public_path__ + "static/media/Discord.cd2ee80f.svg";